export default {
  'token.title': 'Manage Tokens for Reports',
  'token.processInstance': 'Process Instance',
  'token.administration': 'Administration',
  'token.process': 'Process',
  'token.request': 'Request',
  'token.generic': 'Generic',
  'token.reportToken': 'Report Token',
  'token.powerBIConnector': 'Power BI Connector',
  'token.dynamicEntity': 'Dynamic Entity',
  'token.trace': 'Trace',
  'token.dataType': 'Data Type',
  'token.headers': 'Headers',
  'token.isSuccessfullyRequest': 'Is Request Successful?',
  'token.logs': 'Logs',
  'token.reportTokenId': 'Report Token ID',
  'token.ip': 'IP',
};
